const articles = [
    { name: "Using Marker Based Augmented Reality to teach autistic eating skills" ,
      dis: "Recently, the use of digital technologies in supporting children with Autism has increased dramatically. We focus on problems that autistic children face in the learning process...",
    link:"https://ieeexplore.ieee.org/document/9319077"
},
    { name: "Enhancing daily life skills learning for children with ASD" ,
    dis: "The proposed work aims to propose a new training system that uses augmented reality to promote the learning of autistic children’s daily life skills. This system proposes an interactive environment in teaching children about new skills with related keywords or phrases...",
    link:"https://link.springer.com/chapter/10.1007%2F978-3-030-70713-2_103"
},
    {name : "أنواع الواقع المعزز",
    dis: " في هذه المقالة سنتعرف على تقنية الواقع المعزز و أنوعها.أولًا يجب علينا فهم الفرق بين الواقع المعزز و الواقع الإفتراضي الواقع الإفتراضي : هو تغيير كامل للبيئة المحيطة بحيث تكون بيئة...",
    link:"https://caramellaapp.com/maimounah0/z5s6GR3h7/anwaa-alwaqa-almazz"
},
]

    export default articles;